import React, { useRef } from 'react';
import { DesktopTHead } from './DesktopTHead';
import { DesktopTFoot } from './DesktopTFoot';
import useStickyHeader from '../../../hooks/useStickyHeader';
import DesktopTBody from './DesktopTBody';

export const DesktopTable = ({
  headerOptions = null,
  footerOptions = null,
  rows,
  isLoading,
  emptyText,
  sortModel,
  stickyHeader,
}) => {
  const tableRef = useRef(null);
  useStickyHeader({ stickyHeader, tableRef, rows });
  
  return (
    <table className="custom-table__table" ref={tableRef}>
      <DesktopTHead headerOptions={headerOptions} sortModel={sortModel} />
      <DesktopTBody rows={rows} isLoading={isLoading} emptyText={emptyText} hasStickyHeader={!!stickyHeader} />
      <DesktopTFoot footerOptions={footerOptions} />
    </table>
  );
};
